import { render } from "./DisciplesEmmaiusDetailsPage.vue?vue&type=template&id=a6ab5942"
import script from "./DisciplesEmmaiusDetailsPage.vue?vue&type=script&lang=js"
export * from "./DisciplesEmmaiusDetailsPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__